import React, { useState, useEffect } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    service: 'sales',
    message: ''
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    const phoneNumber = formData.service === 'sales' ? '+917575808003' : '+917575808004';
    const message = encodeURIComponent(
      `Name: ${formData.name}\nPhone: ${formData.phone}\nEmail: ${formData.email}\nService: ${formData.service}\nMessage: ${formData.message}`
    );
    window.open(`https://wa.me/917575808003?text=${message}`, '_blank');
  };

  return (
    <div className="contact-page">
      <section className="contact-hero">
        <div className="container">
          <div className="contact-hero-content">
            <h1 className="contact-title">Get In Touch</h1>
            <p className="contact-subtitle">We're here to help you with all your automotive needs</p>
          </div>
        </div>
      </section>

      <section className="contact-section" id="service">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2 className="contact-section-title">Contact Information</h2>
              <p className="contact-section-description">
                Reach out to us through any of the following channels. Our team is ready to assist you.
              </p>

              <div className="contact-cards">
                <div className="contact-card sales">
                  <div className="contact-card-icon">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                      <path d="M16 2L4 8V16C4 22.5 7.5 28.5 13 32.5L16 35.5L19 32.5C24.5 28.5 28 22.5 28 16V8L16 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M16 12V20M16 12L10 16M16 12L22 16M16 20L10 24M16 20L22 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <h3>Sales</h3>
                  <a href="tel:+917575808003" className="contact-phone">+91 75758 08003</a>
                  <a href="tel:+917575808003" className="contact-btn">Call Now</a>
                </div>

                <div className="contact-card service">
                  <div className="contact-card-icon">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                      <path d="M8 16H24M8 16L12 12M8 16L12 20M24 16L20 12M24 16L20 20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <circle cx="16" cy="16" r="14" stroke="currentColor" strokeWidth="2"/>
                    </svg>
                  </div>
                  <h3>Service</h3>
                  <a href="tel:+917575808004" className="contact-phone">+91 75758 08004</a>
                  <a href="tel:+917575808004" className="contact-btn">Call Now</a>
                </div>
              </div>

              <div className="contact-locations">
                <h3 className="contact-locations-title">Visit Our Showrooms</h3>
                <div className="contact-location-item">
                  <strong>Palanpur:</strong>
                  <p>Abu Road Highway, Near Gayatri Temple, Tirupati Rajnagar, Palanpur, Gujarat</p>
                </div>
                <div className="contact-location-item">
                  <strong>Deesa:</strong>
                  <p>Deesa–Palanpur Highway, Near Bajaj Showroom, Deesa – 385535</p>
                </div>
                <div className="contact-location-item">
                  <strong>Patan:</strong>
                  <p>Patan–Unjha Highway, Near Hansapur, Patan – 384265</p>
                </div>
              </div>
            </div>

            <div className="contact-form-wrapper">
              <h2 className="contact-form-title">Send Us a Message</h2>
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Your full name"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Phone Number *</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    placeholder="+91 12345 67890"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="your.email@example.com"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="service">Service Type *</label>
                  <select
                    id="service"
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                    required
                  >
                    <option value="sales">Sales Inquiry</option>
                    <option value="service">Service Booking</option>
                    <option value="spares">Spare Parts</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows="5"
                    placeholder="Tell us how we can help you..."
                  ></textarea>
                </div>

                <button type="submit" className="form-submit-btn">
                  Send Message
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M2.5 17.5L17.5 2.5M17.5 2.5H7.5M17.5 2.5V12.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;

